import { formatMoney } from "../../../../utils/format"

export const formatKsh = (value) => `Ksh ${formatMoney(value || 0)}`

export const COMPANY_KIND_LABELS = {
  rentals_company: "Rentals company",
  rentals_property: "Rentals property",
  standalone: "Standalone",
}

const ENTITY_TYPE_LABELS = {
  individual: "Individual",
  business: "SME",
  company: "LTD/LLC/Inc",
}

// The admin companies list is split into one list per biller type. Rentals
// companies were never registered with a type, so they get their own list.
export const COMPANY_CATEGORIES = [
  { key: "individual", label: ENTITY_TYPE_LABELS.individual, empty: "No individual billers yet." },
  { key: "business", label: ENTITY_TYPE_LABELS.business, empty: "No SME billers yet." },
  { key: "company", label: ENTITY_TYPE_LABELS.company, empty: "No LTD/LLC/Inc billers yet." },
  { key: "rentals", label: "Rentals", empty: "No Rentals companies yet." },
]

export const getCompanyKindLabel = (kind) => COMPANY_KIND_LABELS[kind] || COMPANY_KIND_LABELS.standalone

// A standalone company with no saved type counts as LTD/LLC/Inc, the same
// default the registration details use.
export const getCompanyCategory = (company) => {
  if (company?.kind !== "standalone") return "rentals"
  const entityType = company?.registration?.entityType
  return entityType === "individual" || entityType === "business" ? entityType : "company"
}

// Only standalone companies were registered as one of the three entity types.
export const getEntityTypeLabel = (company) =>
  company?.kind === "standalone" ? ENTITY_TYPE_LABELS[company?.registration?.entityType] || ENTITY_TYPE_LABELS.company : ""

export const getRegistrationDetails = (company) => {
  const registration = company?.registration || {}
  if (company?.kind !== "standalone") return []
  if (registration.entityType === "individual") {
    return registration.alsoKnownAs ? [`A.K.A ${registration.alsoKnownAs}`] : []
  }
  if (registration.entityType === "business") {
    const location = [registration.businessCityTown, registration.businessLocation || registration.location, registration.businessArea]
      .filter(Boolean)
      .join(", ")
    return [registration.businessType, location].filter(Boolean)
  }
  return [registration.location, registration.serviceOffered].filter(Boolean)
}

const normalize = (value) => String(value || "").trim().toLowerCase()

const includesQuery = (values, query) => values.some((value) => normalize(value).includes(query))

export const matchesCompanySearch = (company, rawQuery) => {
  const query = normalize(rawQuery)
  if (!query) return true
  const customers = Array.isArray(company?.customers) ? company.customers : []
  return includesQuery(
    [
      company?.name,
      company?.owner?.name,
      company?.owner?.phone,
      getCompanyKindLabel(company?.kind),
      ...getRegistrationDetails(company),
      ...customers.flatMap((customer) => [customer?.name, customer?.phone]),
    ],
    query
  )
}

export const matchesWalletSearch = (wallet, rawQuery) => {
  const query = normalize(rawQuery)
  if (!query) return true
  return includesQuery([wallet?.name, wallet?.phone, ...(wallet?.companies || [])], query)
}

export const matchesPropertyWalletSearch = (wallet, rawQuery) => {
  const query = normalize(rawQuery)
  if (!query) return true
  return includesQuery([wallet?.propertyName, wallet?.landlordName], query)
}

export const plural = (count, word, pluralWord = `${word}s`) => `${count} ${Number(count) === 1 ? word : pluralWord}`
